import { ActionDefinitionType } from '../types/DropDownTypes';

type DropDownActionProps = {
  item: ActionDefinitionType;
  onClicked: () => void;
};

const DropDownAction = ({
  item,
  onClicked,
}: DropDownActionProps): JSX.Element => {
  const onSelectedItem = () => {
    onClicked();
    item.value();
  };

  return (
    <button
      className='group font-medium text-base text-gray-darkest tracking-tight focus:outline-none flex flex-row items-center w-full text-left px-3 py-2 hover:bg-gray-lightest rounded-md'
      onClick={onSelectedItem}
    >
      {item.icon ? (
        <div className='mr-2'>{item.icon()}</div>
      ) : (
        <div className='bg-gray w-2 h-2 rounded-full mr-3 group-hover:bg-green'></div>
      )}

      {item.label}
    </button>
  );
};

export default DropDownAction;
